import styled from 'styled-components'

import { CircularLoader } from '@blade/ui-kit'
import { useTranslation } from '@root/shared/localization'
import { RectangleNetworkBackground } from '@root/shared/ui/background/rectangle-network'

import type { ClassNameProps, StyleProps } from '@root/shared/react'

type DataTableLoadingProps = {} & ClassNameProps & StyleProps

export const DataTableLoading: React.FC<DataTableLoadingProps> = ({
  className,
  style,
}) => {
  const { t } = useTranslation()
  return (
    <Root className={className} style={style}>
      <LoaderContainer>
        <CircularLoader size={18} />
        <LoaderText>{t('common.loading')}</LoaderText>
      </LoaderContainer>
    </Root>
  )
}

const Root = styled.div`
  ${RectangleNetworkBackground}

  display: grid;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`

const LoaderContainer = styled.div`
  display: grid;
  place-items: center;
  justify-content: center;
  grid-template-rows: auto auto;

  gap: 10px;
`

const LoaderText = styled.span`
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: var(--text-11);
`
